import { assignShortcut } from "@/action/actions";
import { boardActions } from "@/action/boardActions";
import { cardActions } from "@/action/cardActions";
import { drawActions } from "@/action/drawActions";
import { navigationActions } from "@/action/navigationActions";
import { selectionActions } from "@/action/selectionActions";
import { toggleActions } from "@/action/toggleActions";
import type { Action } from "@/action/types";
import { useGlobalI18n } from "@/translations/i18n";
import type { DummyKey, Key } from "@/utils/shortcut/key";
import { dummyKey, key } from "@/utils/shortcut/key";

const { t } = useGlobalI18n();

type ActionWithoutParams = [Action, Key];
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- actions with dummy shortcut can have any parameters
type ActionWithDummyKey = [Action<any[]>, DummyKey];

export function assignShortcuts() {
  const keyMap: Array<ActionWithoutParams | ActionWithDummyKey> = [
    [boardActions.screenshot, key("KeyE", "altCtrl")],
    [boardActions.smallerCardSize, key("ArrowDown", "altCtrl")],
    [boardActions.biggerCardSize, key("ArrowUp", "altCtrl")],
    [boardActions.zoomToRegion, dummyKey(() => t("mouse.doubleClick"))],

    [toggleActions.toggleStickyMagnify, key("KeyX")],
    [toggleActions.hideDraw, key("Escape")],
    [toggleActions.showStatGraphs, key("KeyJ", "altCtrl")],
    [toggleActions.showStats, key("KeyI", "altCtrl")],
    [toggleActions.showTeamObjectives, key("KeyO", "altCtrl")],
    [toggleActions.toggleSearch, key("KeyF", "altCtrl")],
    [toggleActions.toggleBoardHistory, key("KeyH")],
    [toggleActions.toggleCardHistory, key("KeyH")],
    [toggleActions.showTimer, key("KeyT", "altCtrl")],
    [toggleActions.toggleTrailingPointerMode, key("KeyA", "shift")],
    [toggleActions.toggleTrailingPointer, key("KeyA")],
    [toggleActions.togglePanMode, key(" ", "shift")],
    [toggleActions.togglePan, key(" ")],
    [toggleActions.showSettings, key(",", "altCtrl")],
    [toggleActions.showShortcuts, key("?")],
    [toggleActions.toggleWorkMode, key("KeyM", "shift")],

    [selectionActions.undo, key("z", "altCtrl")],

    [drawActions.removeShape, key("Backspace")],

    [cardActions.openAssigneeDropdown, key("KeyA")],
    [cardActions.openLinkModal, key("KeyL")],
    [cardActions.addAtPointer, key("KeyN")],
    [cardActions.togglePalette, dummyKey("KeyN")],
    [cardActions.duplicate, key("KeyD", "altCtrl")],

    [navigationActions.showMyWork, key("KeyW")],
    [navigationActions.showKanban, key("KeyK")],
  ];

  for (const [action, key] of keyMap) {
    assignShortcut(action, key);
  }
}
